export { default as determineLocale } from './determineLocale';
export { default as parseLocale } from './parseLocale';
export { default as storeToPdcMapping } from './storeToPdcMapping';
export default from './l10n';
